import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PageLoader } from './components/PageLoader';
import {
  HeroSpline,
  ProductsShowcase,
  HowItWorks,
  FeatureGrid,
  AgentStudioTeaser,
  CaseStudiesTeaser,
  Industries,
  CTASection,
  IntegrationsMarquee,
  HeaderNew,
  FooterNew,
} from './components/home';
import { ContactModal } from './components/ContactModal';
import { About } from './pages/About';
import Solutions from './pages/Solutions';
import { SolutionDetail } from './pages/SolutionDetail';
import { AgentStudio } from './pages/AgentStudio';
import { Contact } from './pages/Contact';
import { UseCases } from './pages/UseCases';
import { CaseStudies } from './pages/CaseStudies';
import { CaseStudyDetail } from './pages/CaseStudyDetail';
import { Pricing } from './pages/Pricing';
import { ComingSoon } from './pages/ComingSoon';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import './App.css';

function Home() {
  return (
    <main>
      <HeroSpline />
      <ProductsShowcase />
      <HowItWorks />
      <FeatureGrid />
      <IntegrationsMarquee />
      <AgentStudioTeaser />
      <CaseStudiesTeaser />
      <Industries />
      <CTASection />
    </main>
  );
}

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [siteLoaded, setSiteLoaded] = useState(false);
  const handleContactClick = () => setIsContactModalOpen(true);
  const handleCloseModal = () => setIsContactModalOpen(false);

  return (
    <BrowserRouter>
      <div className="App">
        {!siteLoaded && <PageLoader onDone={() => setSiteLoaded(true)} />}

        {/* Ambient mesh background */}
        <div className="site-mesh" aria-hidden="true">
          <div className="mesh-orb mesh-orb-1" />
          <div className="mesh-orb mesh-orb-2" />
          <div className="mesh-orb mesh-orb-3" />
        </div>

        <HeaderNew onContactClick={handleContactClick} />

        <Routes>
          <Route path="/" element={<Home />} />

          {/* Solutions */}
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />

          {/* Agent Studio + Contact */}
          <Route path="/agent-studio" element={<AgentStudio />} />
          <Route path="/contact" element={<Contact />} />

          {/* Trust pages */}
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blog" element={<ComingSoon title="Blog" blurb="We’re writing about building production AI agents. Check back soon — or reach out if you want to talk shop." />} />
          <Route path="/changelog" element={<ComingSoon title="Changelog" blurb="Product updates and Agent Studio progress will land here. Join the waitlist to get notified." />} />

          <Route path="/about" element={<About />} />
          <Route path="/use-cases" element={<UseCases />} />

          {/* Legal */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Retired routes */}
          <Route path="/products" element={<Navigate to="/solutions" replace />} />
          <Route path="/platform" element={<Navigate to="/solutions" replace />} />
          <Route path="/early-access" element={<Navigate to="/contact" replace />} />
        </Routes>

        <FooterNew />
        <ContactModal isOpen={isContactModalOpen} onClose={handleCloseModal} />
      </div>
    </BrowserRouter>
  );
}

export default App;
